import React from "react";

export default function Udsv4Webinars() {
  return (
    <div>
      <div className="uk-overflow-auto uk-margin-bottom uk-box-shadow-small">
        <table className="uk-table uk-table-striped set-min-width-640px uk-width-1-1">
          <tbody>
            {formsTrainings.map((form, index) => (
              <tr key={index}>
                <td className="bolder uk-text-nowrap">{form.form}</td>
                <td className="">{form.description}</td>
                <td className="uk-flex uk-flex-around uk-width-small ">
                  <a
                    className="uk-button uk-margin-remove uk-button-link uk-text-primary"
                    href={form.slides}
                    title={`${form.form} slides`}
                    data-uk-icon="icon: file-pdf"
                  ></a>
                  <a
                    className="uk-button uk-margin-remove uk-button-link uk-text-primary"
                    href={form.href}
                    title={`${form.form} video`}
                    data-uk-icon="icon: youtube"
                  ></a>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

const formsTrainings = [
  {
    form: "Forms A1 & A2",
    description: "Presented by Clinical Task Force Member Dr. Greg Jicha of University of Kentucky ADRC.",
    href: "https://www.youtube.com/watch?v=dmdqjW4chk0",
    slides:
      "https://files.alz.washington.edu/UDS4/clinical-forms-training-slides/a1-a2-participant-and-co-participant-demographics.pptx",
  },
  {
    form: "Form A1a",
    description:
      "Presented by Clinical Task Force Members Dr. Lisa Barnes of Rush University ADRC and Dr. Megan Zuelsdorff of UW Madison ADRC.",
    href: "https://www.youtube.com/watch?v=ydl9qbJZ-H0",
    slides: "https://files.alz.washington.edu/UDS4/clinical-forms-training-slides/a1a-sdoh.pptx",
  },
  {
    form: "Form A4",
    description: "Presented by Clinical Task Force Member Dr. Teresa Gomez-Isla of Massachusetts ADRC.",
    href: "https://www.youtube.com/watch?v=UOqMPDrbF3I",
    slides: "https://files.alz.washington.edu/UDS4/clinical-forms-training-slides/a4-medications-form.pptx",
  },
  {
    form: "Form A4a",
    description: "Presented by Clinical Task Force Member Dr. Suzanne Schindler of Washington University ADRC.",
    href: "https://www.youtube.com/watch?v=NTxChWuRrbI",
    slides: "https://files.alz.washington.edu/UDS4/clinical-forms-training-slides/a4a-adrd-specific-treatments.pptx",
  },
  {
    form: "Form A5/D2",
    description: "Presented by Clinical Task Force Member Dr. Aimee Pierce of OHSU ADRC.",
    href: "https://www.youtube.com/watch?v=WEqz0lysv_Q",
    slides: "https://files.alz.washington.edu/UDS4/clinical-forms-training-slides/a5d2-health-history-form.pptx",
  },
  {
    form: "Form B3",
    description: "Presented by Clinical Task Force Member Dr. Brad Boeve of Mayo Clinic ADRC.",
    href: "https://www.youtube.com/watch?v=5Wwrie0tjhM",
    slides: "https://files.alz.washington.edu/UDS4/clinical-forms-training-slides/b3-updrs.pptx",
  },
  {
    form: "Form B8",
    description: "Presented by Clinical Task Force Member Dr. Brad Boeve of Mayo Clinic ADRC.",
    href: "https://www.youtube.com/watch?v=MxzQKbSKMr4",
    slides: "https://files.alz.washington.edu/UDS4/clinical-forms-training-slides/b8-neuro-exam.pptx",
  },
  {
    form: "Form B9",
    description: "Presented by Clinical Task Force Member Dr. Kostas Lyketsos of Johns Hopkins ADRC.",
    href: "https://www.youtube.com/watch?v=fQ_Ehtumc9U",
    slides:
      "https://files.alz.washington.edu/UDS4/clinical-forms-training-slides/b9-clinician-judgement-of-symptoms.pptx",
  },
  {
    form: "Form C2/C2T",
    description:
      "Presented by Clinical Task Force Members Dr. Lisa Barnes of Rush University ADRC and Dr. Andy Saykin of Indiana ADRC.",
    href: "https://www.youtube.com/watch?v=w5e4_wJer80",
    slides: "https://files.alz.washington.edu/UDS4/clinical-forms-training-slides/c2-neuropsych-battery.pptx",
  },
  {
    form: "Form D1a",
    description:
      "Presented by Clinical Task Force Members Dr. Jeff Burns of Kansas University ADRC, Dr. Andy Saykin of Indiana ADRC, and Dr. Kostas Lyketsos of Johns Hopkins ADRC.",
    href: "https://www.youtube.com/watch?v=aJbBsKJhgnQ",
    slides: "https://files.alz.washington.edu/UDS4/clinical-forms-training-slides/d1a-clinical-syndrome.pptx",
  },
  {
    form: "Form D1b",
    description: "Presented by Clinical Task Force Member Dr. Jeff Burns of Kansas University ADRC.",
    href: "https://www.youtube.com/watch?v=vMKNphdQhRw",
    slides:
      "https://files.alz.washington.edu/UDS4/clinical-forms-training-slides/d1b-biomarkers-etiological-diagnosis.pptx",
  },
  //
];
